export { default as injectGlobalFonts } from './static/fonts.js';
var fontFamily = "Helvetica, Arial, sans-serif";
var circularFontFamily = "AxLLCircular, Helvetica, Arial, sans-serif";
var dinFontFamily = circularFontFamily;
export { circularFontFamily, dinFontFamily, fontFamily };
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZm9udHMuanMiLCJzb3VyY2VzIjpbXSwic291cmNlc0NvbnRlbnQiOltdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiIn0=
